import start from '../../../../common/microservices/loaders/lazy-microservices'

start(() => import('./render'), 'lazy_microservices__root', {
  lazyStoreManagerLoader: () => import('../../../../common/microservices/lazy-store-manager'),
})
